import React, { useState } from 'react';
import Modal from './Modal';
import flyer from './images/events/najdete-klid.jpg';
import { lessonEvents } from './lessonEvents';

export default function UpcomingEvents() {
    const [selectedEvent, setSelectedEvent] = useState(null);
    return <section id="upcoming-events" className="upcoming-events" aria-labelledby="upcoming-events-title">
        <div className="section-heading">
            <p className="eyebrow">Dvě cesty ke společné praxi</p>
            <h2 id="upcoming-events-title">Nadcházející akce</h2>
            <p>Vyberte si svou harmonizační sestavu. Setkáváme se v pondělí a ve středu od 18:00.</p>
        </div>
        <article className="featured-event">
            <button type="button" className="event-poster" aria-label="Zvětšit leták: Najděte klid v pohybu" onClick={() => setSelectedEvent({theme: 'Najděte klid v pohybu', poster: flyer, day: 'Pondělí a středa'})}><img src={flyer} alt="Najděte klid v pohybu. Qigong s Tomášem Číhalem v Hale Krašovská v Plzni, pondělí a středa od 18:00." width="1054" height="1492" loading="lazy" decoding="async" /><span aria-hidden="true">Zvětšit leták ↗</span></button>
            <div className="event-copy"><p className="eyebrow">Qigong s Tomášem Číhalem</p><h3>Najděte klid v pohybu</h3><p className="event-description">Pohyb, dech a vnitřní rovnováha. Přijďte na společnou praxi do Haly Krašovská v Plzni.</p><p>Pondělí a středa od 18:00</p><a href="#schedule" className="text-link">Lekce a přihlášení <span aria-hidden="true">↗</span></a></div>
        </article>
        <div className="upcoming-events-grid">{lessonEvents.map(event => <article className="upcoming-event" key={event.id}>
            <button type="button" className="event-poster" onClick={() => setSelectedEvent(event)} aria-label={`Zvětšit plakát: ${event.theme}`}>
                <img src={event.poster} alt={`${event.day} od 18:00 – ${event.theme}. Autorská sestava Tomáše Číhala.`} width="1024" height="1536" loading="lazy" decoding="async" />
                <span aria-hidden="true">Zvětšit plakát ↗</span>
            </button>
            <div className="event-copy">
                <p className="eyebrow">{event.day} · od 18:00</p>
                <p className="event-type">Harmonizační sestava</p>
                <h3>{event.theme}</h3>
                <p className="event-description">{event.description}</p>
                <a href="tel:+420734327357" className="text-link">Domluvit účast <span aria-hidden="true">↗</span></a>
            </div>
        </article>)}</div>
        {selectedEvent && <Modal label={`Plakát: ${selectedEvent.theme}`} onClose={() => setSelectedEvent(null)}>
            <img src={selectedEvent.poster} alt={`${selectedEvent.day} od 18:00 – ${selectedEvent.theme}`} className="modal-image" width="1024" height="1536" />
        </Modal>}
    </section>;
}
